import { IAgreementChangeReasonInterface } from '../../../APIPackage/CatalogsModule/interfaces/IAgreementChangeReason';
import { IAgreementChangeReasonSelectOption } from '../interfaces/IAgreementChangeReasonSelectOption';

export const createAgreementChangeReasonSelectOption = (
  option: IAgreementChangeReasonInterface,
): IAgreementChangeReasonSelectOption => ({
  ...option,
  value: option.code,
  label: option.name,
});
